import React from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import CompletedImage from './completed.svg'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles({
  content: {
    height: 200,
    display: 'flex',
    alignItems: 'center'
  },
  title: {
    textAlign: 'center'
  }
})

export default function MessageDialog(props) {

  const { open, add, close } = props

  const classes = useStyles()

  return (
    <Dialog
      fullWidth
      maxWidth={'sm'}
      open={open}
      onClose={close}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title" classes={{
        root: classes.title
      }}>{'Thank you for your submission!'}</DialogTitle>
      <DialogContent classes={{
        root: classes.content
      }}>
        <div style={{
          backgroundImage: `url(${CompletedImage})`, 
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          height: '90%', 
          width: '100%'}} />
      </DialogContent>
      <DialogActions>
        <Button onClick={add} color="primary" autoFocus>
            Add More Content
        </Button>
        <Button onClick={close} color="primary">
            Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}
